import { FC } from 'react'
import { useParams } from 'react-router-dom'
import { HelpList, Help } from 'components/Help'
import { UserProtectedRoute } from 'routes'

// /help renders the knowledge base list, /help/:id the document preview.
const HelpPage: FC = () => {
  const { id } = useParams()

  return <UserProtectedRoute>{id ? <Help /> : <HelpList />}</UserProtectedRoute>
}

export default HelpPage
